var map = {
	"./aparthotelclub/ic_whatsapp_circle.png": 94900,
	"./beachful/ic_whatsapp_circle.png": 16102,
	"./castlepedia/ic_whatsapp_circle.png": 89580,
	"./cocktayl/ic_whatsapp_circle.png": 79220,
	"./ic_whatsapp_circle.png": 97299,
	"./luxresortclub/ic_whatsapp_circle.png": 76698,
	"./parkful/ic_whatsapp_circle.png": 66824,
	"./prefabworld/ic_whatsapp_circle.png": 14412,
	"./rooftopclub/ic_whatsapp_circle.png": 23473,
	"./spaclub/ic_whatsapp_circle.png": 42219,
	"./worldcasino/ic_whatsapp_circle.png": 77254,
	"./zoopedia/ic_whatsapp_circle.png": 45350
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44219;